module.exports = __webpack_public_path__ + "static/media/St._Louis_Blues.48b9696d.svg";